import { state$ } from "../globalState";
import UserService from "../../services/UserService";
import { PersonnelService } from "../../services/PersonnelService";
import { catchError } from "../../services/DaoService";

// Cache partagé, chargé une seule fois : utilisé par tous les sélecteurs de
// responsable affichés en boucle dans les listes (BacklogItem, tables, hero…)
// pour éviter un appel API par élément affiché.
export const directoriesState = {
    async loadUsers() {
        if (state$.usersDirectory.loaded.get()) return;
        try {
            const response = await UserService.getInstance().all();
            state$.usersDirectory.list.set(response.data);
            state$.usersDirectory.loaded.set(true);
        } catch (error) {
            catchError(error);
        }
    },

    async loadPersonnels() {
        if (state$.personnelsDirectory.loaded.get()) return;
        try {
            const response = await PersonnelService.getInstance().all();
            state$.personnelsDirectory.list.set(response.data);
            state$.personnelsDirectory.loaded.set(true);
        } catch (error) {
            catchError(error);
        }
    },
};
